// extracted by mini-css-extract-plugin
export default {"main":"RestaurantsLoader_main__syDtv","logo":"RestaurantsLoader_logo__bUSCT"};